export default "__VITE_ASSET__DFEZWEOm__"